/* eslint-disable */
'use strict';

import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/pages/Login/index';
import auth from '@/middleware/auth';
import App from '@/App';

Vue.use(Router);

const routes = [
  /*{
    path: '/',
    name: 'App',
    component: App,
  },
   {
    path: '/chat',
    name:'Chat',
    component:()=>import('@/components/pages/Chat/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  }, */
  {
    path:'/iframe',
    name:'Iframe',
    component:()=>import('@/components/pages/Iframe/index')
  },
  {
    path: '/main',
    name:'Main',
    component:()=>import('@/components/pages/MainPage/Main'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/operator',
    name:'Complaints',
    component:()=>import('@/components/pages/Complaints/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/newrequest',
    name:'NewRequest',
    component:()=>import('@/components/pages/NewRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/citizenrequests/:id',
    name:'CitizenRequest',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/requests/:id',
    name:'CitizenRequest',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/cancelledrequests/:id',
    name:'CancelledRequest',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/obscurerequests/:id',
    name:'ObscureRequest',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/notbelongrequests/:id',
    name:'NotBelongRequest',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path:'/citizenanswereds/:id',
    name:'CitizenAnswered',
    component:()=>import('@/components/pages/CitizenRequest/index'),
    meta:{
      'layout':'app',
      'middleware': auth
    }
  },
  {
    path: '/viewdetails/:id',
    name: 'vdetails',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/assignforcomments/:id',
    name: 'sdetails',
    component: ()=>import('@/components/pages/CommentDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/headofficeadditions/:id',
    name: 'headofficeadd',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/deletedetails/:id',
    name: 'deldetails',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/assestmentdetails/:id',
    name: 'assestdetails',
    component:()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/restartdetails/:id',
    name: 'resdetails',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/executivesentbackdetails/:id',
    name: 'executivesentback',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/headoffsentbackdetails/:id',
    name: 'headsentback',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/executingdetails/:id',
    name: 'executingdetails',
    component: ()=>import("@/components/pages/ActionDetails/index"),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/executorsents/:id',
    name: 'executorsents',
    component: ()=>import("@/components/pages/ActionDetails/index"),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/completeddetails/:id',
    name: 'completeddetails',
    component: ()=>import("@/components/pages/ActionDetails/index"),
    props:{
      type:'ASSESTMENT'
    },
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/lates/:id',
    name: 'lates',
    component: ()=>import("@/components/pages/ExecuteDetails/index"),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/rejecteddetails/:id',
    name: 'rejecteddetails',
    component: ()=>import('@/components/pages/ActionDetails/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/problems/:id',
    name: 'problem',
    component: ()=>import('@/components/pages/Progress/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/cprogress/:id',
    name: 'cprogress',
    component: ()=>import('@/components/pages/Progress/index'),
    meta: {
      'layout': 'app',
      'middleware': auth
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: ()=>import('@/components/pages/ForgotPassword/index'),
  },
  {
    path:'/404',
    name:'notfound',
    component:()=>import('@/components/pages/Page404/index'),
    meta:{
      'middleware': auth
    }
  },
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '*',
    redirect: '/404'
  }
];

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: routes
});

const nextFactory = (context, middleware, index) => {
  let subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;
  return (...parameters) => {
    context.next(...parameters);
    let nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context,
      next: nextMiddleware
    });
  };
}

router.beforeEach((to, from, next) => {
 //console.log(to);
  if (to.meta.middleware) {
    let middleware = to.meta.middleware instanceof Array ? to.meta.middleware : [to.meta.middleware];
    let context = {
      from,
      next,
      router,
      to
    };
    let nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context,
      next: nextMiddleware
    });
  }
  return next();
})

export default router;
